module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "siteBookings"
  }, [_vm._m(0), _vm._v(" "), _c('el-table', {
    staticClass: "field-table no-pointer",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.bookings,
      "empty-text": "No Bookings"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "Date",
      "header-align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "field_name",
      "label": "Field",
      "header-align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "scene_name",
      "label": "Scene",
      "header-align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "start_time",
      "label": "Time On",
      "header-align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "end_time",
      "label": "Time Off",
      "header-align": "center"
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panelheader"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Bookings")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cdd1c3ba","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteBookings.vue
// module id = 822
// module chunks = 4